import React, { useEffect, useState } from "react";
import Heading from "../Heading";
import TableCard from "../TableCard";
import CardContainer from "../Card/cardContainer";
import {
  listingCommonDefaulter,
  modalInitialValue,
  multiTabFormModalController,
} from "../../helpers/commonHelpers";
import ModalContainer from "../Modal";
import { meetingFormLayout } from "../../Data/FormsLayout/meetingFormLayout";
import { useDispatch, useSelector } from "react-redux";
import { meetingListAction } from "../actions/meetingAction";
import { deleteMeeting, updateMeetingHandler } from "../../apiParsing/meeting";
import { addActionColumn } from "../../helpers/companyHelpers";
import { apipaths } from "./../../services/apiPaths";
import { Dropdown } from "antd";
import { BarsOutlined } from "@ant-design/icons";
import { menu } from "./../../Data/Columns/meetingColumns";
import { sendRequest } from "../../services";
import Swal from "sweetalert2";
import { companyListAction } from "../actions/comanyAction";
import { projectListAction } from "../actions/projectAction";
import { useNavigate } from "react-router-dom";
import useTranslation from "../customHooks/translations";
import moment from "moment";

function Meetings() {
  const [modal, setModal] = useState(modalInitialValue);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { meet } = useSelector((state) => state.meet);
  const { employees } = useSelector((state) => state.employee);
  const { projects } = useSelector((state) => state.project);
  const { clients } = useSelector((state) => state.client);
  const { companies } = useSelector((state) => state.company);
  const selectedCompanyName = "";
  const translation = useTranslation();

  useEffect(() => {
    dispatch(meetingListAction());
    dispatch(companyListAction());
    dispatch(projectListAction());
  }, []);

  useEffect(() => {
    if (projects && clients && companies && employees) {
      const arr = [projects, clients, companies, employees];
      const kerArr = ["project_id", "client_id", "company_id", "employee_id"];
      listingCommonDefaulter(arr, meetingFormLayout.meeting, kerArr);
    }
  }, [projects, clients, companies, employees]);

  const meetingColumns = [
    {
      title: "ID",
      dataIndex: "meeting_id",
      sorter: (a, b) => a.meeting_id - b.meeting_id,
    },
    {
      title: "Subject",
      dataIndex: "subject",
      sorter: (a, b) => a?.subject?.localeCompare(b?.subject),
      render: (subject, data) => {
        return (
          <>
            <label
              style={{ color: "#1890ff" }}
              onClick={() => {
                navigate(`/edit-meetings/${data.meeting_id}`);
              }}
            >
              {subject}
            </label>
          </>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "startdate",
      sorter: (a, b) => moment(a.startdate).unix() - moment(b.startdate).unix(),
    },
    {
      title: "Start Time",
      dataIndex: "starttime",
      sorter: (a, b) => a.starttime.localeCompare(b.starttime),
    },
    {
      title: "End Time",
      dataIndex: "endtime",
      sorter: (a, b) => a.endtime.localeCompare(b.endtime),
    },
    {
      title: "Venue",
      dataIndex: "venue",
      sorter: (a, b) => a.venue.localeCompare(b.venue),
    },
    {
      title: "Client",
      dataIndex: "client",
      sorter: (a, b) =>
        a?.client?.first_name.localeCompare(b?.client?.first_name),
      render: (client_id, row) => {
        const client = row["client"];
        if (client) return client.first_name + " " + client.last_name;
        else return "";
      },
    },
    {
      title: "Company",
      dataIndex: "company",
      sorter: (a, b) => a?.company?.name.localeCompare(b?.company?.name),
      render: (company_id, row) => {
        let company_name = "";
        const company = row.company;
        if (company && company) company_name = company.name;
        return company_name;
      },
    },
    {
      title: "Projects",
      dataIndex: "project_id",
      sorter: (a, b) => a.project_id - b.project_id,

      render: (project_id, row) => {
        const project = row["project"];
        if (project) return project.name;
        else return "";
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (index) => (
        <div key={index}>
          <Dropdown overlay={menu} placement="bottom" className="action-button">
            <BarsOutlined />
          </Dropdown>
        </div>
      ),
    },
  ];

  const meetingColumnsHome = [
    {
      title: "ID",
      dataIndex: "meeting_id",
      sorter: (a, b) => a.meeting_id - b.meeting_id,
    },
    {
      title: "主題",
      dataIndex: "subject",
      sorter: (a, b) => a?.subject?.localeCompare(b?.subject),
      render: (subject, data) => {
        return (
          <>
            <label
              style={{ color: "#1890ff" }}
              onClick={() => {
                navigate(`/edit-meetings/${data.meeting_id}`);
              }}
            >
              {subject}
            </label>
          </>
        );
      },
    },
    {
      title: "日付",
      dataIndex: "startdate",
      sorter: (a, b) => moment(a.startdate).unix() - moment(b.startdate).unix(),
    },
    {
      title: "開始時間",
      dataIndex: "starttime",
      sorter: (a, b) => a.starttime.localeCompare(b.starttime),
    },
    {
      title: "終了時間",
      dataIndex: "endtime",
      sorter: (a, b) => a.endtime.localeCompare(b.endtime),
    },
    {
      title: "会場",
      dataIndex: "venue",
      sorter: (a, b) => a.venue.localeCompare(b.venue),
    },
    {
      title: "クライアント",
      dataIndex: "client",
      sorter: (a, b) =>
        a?.client?.first_name.localeCompare(b?.client?.first_name),
      render: (client_id, row) => {
        const client = row["client"];
        if (client) return client.first_name + " " + client.last_name;
        else return "";
      },
    },
    {
      title: "会社",
      dataIndex: "company",
      sorter: (a, b) => a?.company?.name.localeCompare(b?.company?.name),
      render: (company_id, row) => {
        let company_name = "";
        const company = row.company;
        if (company && company) company_name = company.name;
        return company_name;
      },
    },
    {
      title: "プロジェクト",
      dataIndex: "project_id",
      sorter: (a, b) => a.project_id - b.project_id,
      render: (project_id, row) => {
        const project = row["project"];
        if (project) return project.name;
        else return "";
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (index) => (
        <div key={index}>
          <Dropdown overlay={menu} placement="bottom" className="action-button">
            <BarsOutlined />
          </Dropdown>
        </div>
      ),
    },
  ];

  const deleteMeetingHandler = (meeting_id) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#1890ff",
    }).then(async ({ isConfirmed }) => {
      if (!isConfirmed) return null;

      const { data } = await sendRequest(apipaths.deleteMeeting, {
        delete_id: meeting_id,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Meeting is deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
      dispatch(meetingListAction());
    });
  };

  return (
    <>
      <ModalContainer
        isOpen={modal.open}
        title={modal.title}
        closeIcon={() => setModal(modalInitialValue)}
        content={modal.content}
        footer={false}
      />
      <div className="main-container">
        <Heading title={translation.meetings} />
        <div className="content-wrapper px-5">
          <CardContainer hideTotal={true} />
        </div>

        <div className="px-5">
          <TableCard
            button={{
              title: translation.add_meeting,
              onClick: () => navigate("/meetings/form/add"),
            }}
            columns={addActionColumn(
              { type: `dropdown`, name: `meetingHome-dropdown` },

              meetingColumns,
              (data) =>
                multiTabFormModalController(
                  setModal,
                  selectedCompanyName,
                  {
                    task: meetingFormLayout.meeting,
                    subTask: meetingFormLayout.task,
                    subTask2: meetingFormLayout.task,
                  },
                  {
                    title1: `${translation.add_meeting}`,
                    title2: `${translation.pre_meeting_task}`,
                    title3: `${translation.post_meeting_task}`,
                  },
                  `edit-meetings-form`,
                  data,
                  (data) => navigate(`edit-meeting${data.meeting_id}`)
                ),
              (meeting_id) => deleteMeetingHandler(meeting_id),
              translation._language
            )}
            jaCol={addActionColumn(
              { type: `dropdown`, name: `meetingHome-dropdown` },

              meetingColumnsHome,
              (data) =>
                multiTabFormModalController(
                  setModal,
                  selectedCompanyName,
                  {
                    task: meetingFormLayout.meeting,
                    subTask: meetingFormLayout.task,
                    subTask2: meetingFormLayout.task,
                  },
                  {
                    title1: `${translation.edit_meetings}`,
                    title2: `${translation.pre_meeting_task}`,
                    title3: `${translation.post_meeting_task}`,
                  },
                  `edit-meetings-form`,
                  data,
                  (data) => navigate(`edit-meeting${data.meeting_id}`)
                ),
              (meeting_id) => deleteMeetingHandler(meeting_id),
              translation._language
            )}
            data={meet}
            title={translation.meetings}
          />
        </div>
      </div>
    </>
  );
}

export default Meetings;
